module.exports = __webpack_public_path__ + "static/img/sy-img2.0587f9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sy-img2.png
// module id = SSiQ
// module chunks = 1